import { v4 as uuidv4 } from "uuid";

const DEVICE_ID_KEY = "rk_client_device_id";

/**
 * Retrieves or generates a stable client device ID.
 * Persists in localStorage.
 * Returns null if localStorage is unavailable.
 */
export function getDeviceId(): string | null {
    try {
        if (typeof window === "undefined" || !window.localStorage) {
            return null;
        }

        let deviceId = localStorage.getItem(DEVICE_ID_KEY);

        if (!deviceId) {
            deviceId = uuidv4();
            localStorage.setItem(DEVICE_ID_KEY, deviceId);
        }

        return deviceId;
    } catch (error) {
        // Gracefully handle storage quotas or access denial
        // Do not log the raw error or ID to console per requirements
        return null;
    }
}
